import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';

import ContentHeader from 'components/ContentHeader';
import ContentFooter from 'components/ContentFooter';

import { PanelSection } from 'components/PanelSections';

import { getProductPrice, formatValue } from '../util';

import SelectProdCard from 'components/SelectProdCard/SelectProdCard';

import Input from './Input';

import 'sass/components/panel';

export default class ProductListPanel extends Component {

	constructor(props) {
		super(props);

		let selectedProducts = this.props.order && this.props.order.products ? this.props.order.products.map( (product)=> {
			return product.id;
		}) : [];

		let products = this.props.order && this.props.order.products ? this.props.products.map( (product)=> {
			let orderProduct = this.props.order.products.find( (oP) => {
				return product.id === oP.id;
			});
			if (orderProduct) {
				return orderProduct;
			} else {
				return product;
			}
		}) : this.props.products;

        products.sort(function(a, b) {
            return a.order > b.order;
        });

        this.state = {
			products : products,
			selectedProducts : selectedProducts
		};
	}

	addProduct (id) {
		let selectedProducts = this.state.selectedProducts;
		if(selectedProducts.indexOf(id) === -1){
			selectedProducts.push(id);
			this.setState({
				selectedProducts : selectedProducts
			});
		}
	}

	removeProduct (id) {
		let selectedProducts = this.state.selectedProducts;
		let index = selectedProducts.indexOf(id);
		//if it exists, pop it out
		if(index !== -1){
			selectedProducts.splice(index, 1);
			this.setState({
				selectedProducts : selectedProducts
			});
		}
	}

	updateProduct (id, event) {
		console.log('updateProduct');
		let value = formatValue(event.target.value, event.target.type);

		console.log(value);

		let products = this.state.products.map( (product)=> {
			if(product.id === id){
				product[event.target.name] = value;
			}

			console.log(product);
			//I should just update total here
			product.total = getProductPrice(product);

			return product;
		});


		this.setState({
			products : products
		});
	}

	updateProductPrice(id, price) {

	}

	render () {
		return(
			<div className="panel full">
				<ContentHeader
					title="Select Products"
					closeable="true"
					onClose={this.props.closeDrawer}
				/>
				<div className="panel-content">
					<div className="container">
						<PanelSection>
							{this.state.products.map( (product, index)=> {

								var selected=this.state.selectedProducts.includes(product.id);

								return(
									<SelectProdCard
										key={index}
										id={product.id}
										selected={selected}
										{...product}
										updateProduct={this.updateProduct.bind(this)}
										addProduct={this.addProduct.bind(this)}
										removeProduct={this.removeProduct.bind(this)}
									/>
								);
							})}
						</PanelSection>
					</div>
				</div>
				<ContentFooter
					onCancel={this.props.hideProductOptions.bind(this)}
					onConfirm={this.props.addProducts.bind(this, this.state.products, this.state.selectedProducts)}
					confirmLabel="Add Products"
				/>
			</div>
	);

	}
}


// WEBPACK FOOTER //
// ./js/components/ProductListPanel.js